module.exports = __webpack_public_path__ + "img/template2.55a4b0e1.svg";